import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=8e9f43e4&"
import script from "./Form2.vue?vue&type=script&lang=js&"
export * from "./Form2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports